import { z } from 'zod';
import type { WarehouseToken } from '@sleed/bizcommerce-api';

/**
 * Warehouse edit form. Mirrors `WarehouseToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Catalog/Warehouses/index.js): cd optional ≤50, nm required ≤100,
 * wt (warehouse type) required, is_disabled boolean, iv boolean, si required. The warehouse type is
 * a lookup over WarehousesApi.getWarehouseTypes (EnumToken id→name).
 */
export const warehouseSchema = z.object({
	id: z.number().optional(),
	cd: z.string().trim().max(50, 'validation.tooLong').nullable(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	wt: z.number({ message: 'validation.required' }),
	is_disabled: z.boolean(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type WarehouseFormValues = z.infer<typeof warehouseSchema>;

export const EMPTY_WAREHOUSE: WarehouseFormValues = {
	cd: '',
	nm: '',
	wt: 0,
	is_disabled: false,
	iv: true,
	si: 0
};

export function tokenToForm(token: WarehouseToken): WarehouseFormValues {
	return {
		id: token.id,
		cd: token.cd ?? '',
		nm: token.nm ?? '',
		wt: token.wt ?? 0,
		is_disabled: token.is_disabled ?? false,
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: WarehouseFormValues): WarehouseToken {
	return {
		id: form.id,
		cd: form.cd?.trim() || null,
		nm: form.nm.trim(),
		wt: form.wt,
		is_disabled: form.is_disabled,
		iv: form.iv,
		si: form.si
	};
}
